import { useContext, useEffect, useMemo, useRef } from "react";

// Contexts
import { CartContext } from "@cart-client/contexts/CartContext";

// Utils
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";
import { hasCartSplashLottie } from "@cart-client/helpers/Cart";

// Constants
import { LOTTIE_ASSETS } from "@swiggy-private/core-ui";

export const usePrefetchSplashLotties = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;
    const splashLottieFetchRef = useRef<boolean>(false);

    const hasSplashLottie = useMemo(() => hasCartSplashLottie(cartResponse), [cartResponse]);

    useEffect(() => {
        if (hasSplashLottie && !splashLottieFetchRef.current) {
            fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.NINETY_NINE_STORE_SPLASH_LOTTIE))
                .then(() => {
                    splashLottieFetchRef.current = true;
                })
                .catch();
        }
    }, [hasSplashLottie]);
};
